import type { FieldPath, FieldValues } from "react-hook-form";
import { CdcSelectField, type CdcSelectFieldProps } from "./cdc-field-helpers";
import type { CdcOption } from "@/i18n/cdc-options";
import countries from "@/data/countries.json" with { type: "json" };

const COUNTRY_OPTIONS: Record<string, readonly CdcOption[]> = countries;
const FALLBACK_LOCALE = "en-US";

export type CdcCountryFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CdcSelectFieldProps<TFieldValues, TName>, "fieldKey" | "options">;

export function CdcCountryField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({ locale, ...rest }: Readonly<CdcCountryFieldProps<TFieldValues, TName>>) {
  const options = COUNTRY_OPTIONS[locale] ?? COUNTRY_OPTIONS[FALLBACK_LOCALE];

  return (
    <CdcSelectField
      {...rest}
      fieldKey="country"
      locale={locale}
      options={options}
    />
  );
}
